import React, { Suspense } from 'react';
import Placeholder from '@web/plugins/placeholder';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import BottomTab from '@web-components/home/BottomTab';
import RootNavigator from '@web/navigation/RootNavigator';
import ProfileNavigator from '@web/navigation/ProfileNavigator';

const Tab = createBottomTabNavigator();

const TabNavigator = () => {
  const showOnScreens = ['HomeScreen', 'ProfileScreen', 'Profile', 'Shop'];

  const isHideTabBar = (routes, index = -1) => {
    let routeName = '';
    if (routes.state) {
      const idx =
        index > -1 ? index : routes.state.index ? routes.state.index : 0;
      const route = routes.state.routes[idx];

      if (route.state) {
        return isHideTabBar(route, 0);
      } else {
        routeName = route.name;
      }
    }
    return Boolean(showOnScreens.includes(routeName));
  };

  return (
    <Suspense fallback={<Placeholder />}>
      <Tab.Navigator
        tabBar={(props) => {
          if (!global.isNative) {
            const isHide = !isHideTabBar(props) || global.isWeb;
            if (isHide) {
              return <></>;
            }
          }
          return <BottomTab {...props} />;
        }}
        backBehavior="history"
        screenOptions={{
          tabBarStyle: {
            elevation: 0,
            backgroundColor: 'transparent',
          },
          headerShown: false,
        }}>
        <Tab.Screen name="Shop" component={RootNavigator} />
        <Tab.Screen name="Profile" component={ProfileNavigator} />
      </Tab.Navigator>
    </Suspense>
  );
};

export default TabNavigator;
